import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Tag} from "./fields";
import {Object} from "./Shot";
import {Component} from "./setting";
import {host} from "./api";


export interface ObjectsState {
    collection?: Array<Object>,
    lore?: Array<Object>,
    status: Status,
    error: string | null | undefined
}

const initialState: ObjectsState = {
    collection: [],
    lore: [],
    status: Status.Idle,
    error: null,
}

export const fetchObjectsCollection = createAsyncThunk('fetchObjectsCollection', async (params: {projectId: number, storyId: number}) => {
    const response = await axios.get(`${host}/objects/collection/${params.storyId}`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const fetchObjectsLore = createAsyncThunk('fetchObjectsLore', async (params: {projectId: number, storyId: number}) => {
    const response = await axios.get(`${host}/objects/lore/${params.storyId}`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const saveObject = createAsyncThunk('saveObject', async (params: { projectId: number, object: Object }) => {
    const response = await axios.post(`${host}/objects`,
        params.object,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteObject = createAsyncThunk('deleteObject', async (params: { projectId: number, objectId: number }) => {
    const response = await axios.delete(`${host}/objects/${params.objectId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const removeObjectTag = createAsyncThunk('removeObjectTag', async (params: { projectId: number, objectId: number, tagId: number }) => {
    const response = await axios.delete(`${host}/objects/${params.objectId}/tags/${params.tagId}`,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const addObjectTag = createAsyncThunk('addObjectTag', async (params: { projectId: number, objectId: number, tag: Tag }) => {
    const response = await axios.post(`${host}/objects/${params.objectId}/tags`,
        params.tag,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})


export const objectSlice = createSlice({
    name: 'objects',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(removeObjectTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeObjectTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addObjectTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addObjectTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveObject.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveObject.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteObject.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteObject.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(fetchObjectsCollection.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchObjectsCollection.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.collection = action.payload
            })
            .addCase(fetchObjectsLore.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchObjectsLore.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.lore = action.payload.map((object: Object) => {
                    const component = object as Component
                    return {
                        ...component,
                        layers: component.cover ? [{source: component.cover}] : [],
                        scale: 100,
                        component: component,
                        type: 'Object'
                    }
                })
            })
    }
})
export default objectSlice.reducer;